<template>
  <main class="workflow-tool">
    <header class="wt-wrap wt-hero">
      <NuxtLink :to="localePath('/tools')" class="wt-eyebrow">Free client-work tools</NuxtLink>
      <h1 class="text-4xl font-extrabold tracking-normal sm:text-5xl lg:text-6xl">{{ title }}</h1>
      <p>{{ description }}</p>
      <div class="wt-trust"><span>No signup</span><span>Works in your browser</span><span>Download or print</span></div>
    </header>
    <div class="wt-wrap"><slot /></div>
    <section class="wt-wrap wt-method">
      <slot name="method" />
      <section class="wt-connected">
        <h2>Keep this work connected to the client</h2>
        <p>The free tool creates a standalone record. Workspace369 connects client records, projects, communication and reviewed invoices. Exporting this document does not import it into your workspace or send it to a client.</p>
        <a class="wt-primary" :href="addReferralToUrl('https://app.workspace369.com/signup')" data-conversion-event="start_free_click" data-conversion-label="Client work tool CTA" :data-conversion-location="slug">Manage client work in Workspace369</a>
        <!-- The full trial line sits directly under the trial button (legal B1.1). -->
        <TrialDisclosure />
      </section>
    </section>
  </main>
</template>
<script setup>
import { localizedUrl } from '~/data/locales';
import { buildFreeToolApplication } from '~/utils/structured-data';
const props=defineProps({title:String,description:String,slug:String});
const {localePath,canonicalLocaleCode}=useWorkspaceLocale();const {addReferralToUrl}=useReferral();
useHead(()=>({title:props.title+' | Workspace369',meta:[{name:'description',content:props.description},{property:'og:title',content:props.title},{property:'og:description',content:props.description},{name:'twitter:title',content:props.title},{name:'twitter:description',content:props.description}],link:[{key:'canonical',rel:'canonical',href:localizedUrl('https://workspace369.com',props.slug,canonicalLocaleCode.value)}],script:[{key:'workflow-tool-app',type:'application/ld+json',children:JSON.stringify({'@context':'https://schema.org',...buildFreeToolApplication({name:props.title,url:localizedUrl('https://workspace369.com',props.slug,canonicalLocaleCode.value),description:props.description})})}]}));
</script>
<style src="~/assets/css/workflow-tools.css"></style>
